import { render, staticRenderFns } from "./BuyDetail.vue?vue&type=template&id=0b7e3b10&scoped=true&"
import script from "./BuyDetail.vue?vue&type=script&lang=js&"
export * from "./BuyDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyDetail.vue?vue&type=style&index=0&id=0b7e3b10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e3b10",
  null
  
)

export default component.exports